exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram1-5b-5 .simplest__structure-framework__bottom-box-points>ul>li{font-size:13px}#diagram1-5b-5 .simplest__structure-framework__bottom-box-points>ul{margin-right:2px}#diagram1-5b-5 .simplest__structure-framework__diagram-box{width:160px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5b/diagram1/diagram1.scss
// module id = 1387
// module chunks = 0